// src/context/brandVoice/widgets/fieldPlaceholder.js — the placeholder of one list cell (v200).
//
// `brandVoice.fieldPlaceholder.<field_path>[.<column>]` names the column, then gives an example
// ("Termine*: es. clienti"), like the Fatti tab; a field or column without one keeps the editor's generic
// placeholder (`fallbackKey`), or none when there is no fallback (a scalar box). ⭐ The English column of a bilingual "avoid" list holds ENGLISH text, so its
// placeholder is looked up in English whatever the interface language.
export function fieldPlaceholder(t, { path, column, fallbackKey, lang }) {
  const lng = lang === 'en' ? 'en' : undefined;
  const key = column ? `${path}.${column}` : path;
  const fallback = fallbackKey ? t(fallbackKey, { lng }) : '';
  const text = path ? t(`brandVoice.fieldPlaceholder.${key}`, { lng, defaultValue: fallback }) : fallback;
  return text || undefined;
}
